import React, { Component } from 'react'
import classes from './ProductModal.scss'
import { apiFetch, formatMoney } from 'helpers/utilities'
import { get, find } from 'lodash'
import { connect } from 'react-redux'
import moment from 'moment'

// Actions
import { orderActions } from 'redux/actionCreators'

@connect(state => ({
  cartProductMap: get(state, 'order.cartProductMap') || {}
}), dispatch => ({
  attemptAddToCart: (payload) =>
    dispatch(orderActions.attemptAddToCart(payload))
}))
class ProductModal extends Component {
  constructor(props) {
    super(props)
    this.state = { productImagePaths: [], currentIndex: 0 }
  }
  _price = (unit) => unit[['retail', 'wholesale1', 'wholesale2', 'wholesale3', 'wholesale4'][this.props.userClass]]

  componentWillReceiveProps(nextProps) {
    if (nextProps.visible && !get(this.state.productImages, 0) && get(nextProps, 'product.productCode')) {
      apiFetch({ endpoint: `/product-images/${get(nextProps, 'product.productCode')}` })
        .then(productImages => this.setState({ productImagePaths: productImages.map(({ imagePath }) => imagePath) }))
    }
  }

  _onPrev = () => {
    const length = this.state.productImagePaths.length + 1
    this.setState({
      currentIndex: (this.state.currentIndex + length - 1) % length
    })
  }

  _onNext = () => {
    const length = this.state.productImagePaths.length + 1
    this.setState({
      currentIndex: (this.state.currentIndex + length + 1) % length
    })
  }

  _onAddToCart = () => {
    const { attemptAddToCart, product, selectedUnitId, userClass, amount } = this.props
    const priceField = ['retail', 'wholesale1', 'wholesale2', 'wholesale3', 'wholesale4'][userClass]
    const selectedUnit = find(product.units, unit => `${unit.unitId}` === `${selectedUnitId}`)
    attemptAddToCart({
      productCode: product.productCode,
      amount,
      unitId: selectedUnitId,
      price: selectedUnit[priceField]
    })
  }

  render() {
    const { visible, product: _product, cartProductMap, onAmountChange, onClose, onDelete, onWishlist, selectedUnitId, onUnitChange } = this.props
    const product = _product || {}
    const images = [get(product, 'imagePath')].concat(this.state.productImagePaths.length ? this.state.productImagePaths : [])
    const currentImagePath = images[this.state.currentIndex]
    const smallestUnit = get(find(get(product, 'units') || [], unit => unit.perUnit === 1), 'unit')
    const amount = product
      ? get(cartProductMap, `${product.productCode}-${product.unitId}`) || 1
      : 1

    const selectedUnit = find(product.units, unit => `${unit.unitId}` === selectedUnitId)
    const stockAmount = selectedUnit
      ? Math.floor(product.stockAmount / selectedUnit.perUnit)
      : product.stockAmount

    if (!visible) return null
    return (
      <section className={classes.productOverlay} onClick={onClose}>
        <div className={classes.modal} onClick={e => e.stopPropagation()}>
          {onClose && (
            <div className={classes.btnClose} onClick={onClose}>
              <img src='/images/icon-close.png' width='40' height='40' alt='icon-close' />
            </div>
          )}
          <div className={classes.productName}>{product.productName}</div>
          <div className={classes.row}>
            <div className={classes.colLeft}>
              <span>Generic Name</span>
            </div>
            <div className={classes.colRight}>
              <span>: {product.genericName || '-'}</span>
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.colLeft}>
              <span>บริษัทผู้จัดจำหน่าย</span>
            </div>
            <div className={classes.colRight}>
              <span>: {product.companyName}</span>
            </div>
          </div>
          <div className={classes.row}>
            <div className={classes.colLeft}>
              <span>รหัสสินค้า</span>
            </div>
            <div className={classes.colRight}>
              <span>: {product.productCode}</span>
            </div>
          </div>
          {selectedUnit && selectedUnit.expDate && (
            <div className={classes.row}>
              <div className={classes.colLeft}>
                <b>วันหมดอายุ</b>
              </div>
              <div className={classes.colRight}>
                {moment(selectedUnit.expDate, 'YYYY-MM-DD').diff(moment(), 'month') >= 12
                  ? <b>: รับประกันอายุสินค้าเกิน 12 เดือน</b>
                  : <b>: {moment(selectedUnit.expDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}</b>}
              </div>
            </div>
          )}
          {product.remark && (
            <div className={`${classes.row} ${classes.remark}`}>
              <span>หมายเหตุ: {product.remark}</span>
            </div>
          )}
          <div className={`${classes.row} ${classes.unitSelector}`}>
            <div className={classes.unitHead}>หน่วย</div>
            {(product.units || []).map(({ unit, unitId, perUnit, ...rest }) =>
              <div key={unitId}
                className={`${classes.unitItem} ${`${unitId}` === selectedUnitId && classes.active}`}
                onClick={() => onUnitChange(`${unitId}`)}>
                <div className={classes.unitTitle}>{unit}</div>
                <div className={classes.unitPrice}>{formatMoney(this._price(rest))} บาท</div>
                <div className={classes.perUnit}>({formatMoney(this._price(rest) / (perUnit || 1))} บาท/{smallestUnit})</div>
              </div>
            )}
          </div>
          <div style={{ position: 'relative' }}>
            {images.length > 1 && <img className={`${classes.arrow} ${classes.left}`} onClick={this._onPrev} src='/images/icon-arrow-left.png' alt='icon-arrow-left' />}
            <img className={classes.productImage} src={currentImagePath} role='presentation' />
            {images.length > 1 && <img className={`${classes.arrow} ${classes.right}`} onClick={this._onNext} src='/images/icon-arrow-right.png' alt='icon-arrow-right' />}
            <div className={classes.watermarkWrapper}>
              {Boolean(product.freeDelivery) && <img className={classes.freeDelivery} src='/images/icon-free-shipping.svg' alt='Free Delivery' />}
              <img className={classes.watermark} src='/images/watermark.png' alt='watermark' width='60' height='20' />
            </div>
          </div>
          {product.outOfStock ? (
            <div className={classes.productAmount}>
              <span className='strike-through'>สินค้าหมดชั่วคราว</span>
              {onDelete && Boolean(amount) && (
                <div className={classes.btnCart} onClick={() => onDelete(product.productCode)}>
                  <img style={{ filter: 'brightness(0) invert(1)' }}
                    src='/images/icon-bin-orange.png'
                    alt='icon-bin' width='18' height='25' />
                  <span>นำออกจากรายการ</span>
                </div>
              )}
            </div>
          ) : (
            <div>
              <div className={classes.stockAmount}>
                <strong>คลัง: </strong>
                <span>{stockAmount}</span>
              </div>
              <div className={classes.productAmount}>
                <span>จำนวน</span>
                <input
                  className={get(cartProductMap, [`${product.productCode}-${this.state.selectedUnitId}`, 'amount']) && classes.active}
                  type='number'
                  pattern='[0-9]*'
                  value={this.state.amount}
                  onChange={e => {
                    let _num = e.target.value
                    if (_num && isNaN(_num)) return
                    _num = _num ? parseInt(_num, 10) : 0
                    this.setState({ amount: `${Math.min(_num, stockAmount)}` })
                  }} />
                <span className={classes.stockAmount}></span>
                <div className={classes.btnCart} onClick={this._onAddToCart}>
                  <img src='/images/icon-cart-white.png' alt='icon-cart' width='16' height='15' />
                  <span>ใส่ตะกร้า</span>
                </div>
              </div>
            </div>
          )}
          <div className={`${classes.btnWishlist} ${product.userId && classes.added}`}
            onClick={() => onWishlist(Boolean(product.userId))}>
            <span>{product.userId ? '-' : '+'} WISHLIST</span>
          </div>
          {Boolean(product.description) && (
            <div className={classes.row} style={{ marginTop: 20 }}>
              <div className={classes.colLeft}>
                <span>ข้อบ่งใช้</span>
              </div>
              <div className={classes.colRight} style={{ height: 100, overflow: 'auto' }}>
                <span>: {product.description}</span>
              </div>
            </div>

          )}
        </div>
      </section>
    )
  }
}

export default ProductModal



/** WEBPACK FOOTER **
 ** ./src/components/ProductModal.js
 **/